module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0092.jpg?v=6c305585";